import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { stateOptionsSample, dosageFormulationOptionsConstant } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-return-retrival-modal',
  templateUrl: './return-retrival-modal.component.html',
  styleUrls: ['./return-retrival-modal.component.scss']
})
export class ReturnRetrivalModalComponent implements OnInit {

  @Input() public Content: any;
  formFields;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  retrivalRequestForm: UntypedFormGroup;
  returnList: any;
  typeList: any;
  optionsSelect = stateOptionsSample;
  dosageFormulationOptionsConstant = dosageFormulationOptionsConstant;
  staticformFields: any;

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private commonService: CommonService
  ) { }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }

  ngOnInit() {
    this.getStaticFiledsData('SCR-007');
    this.retrivalRequestForm = new UntypedFormGroup({
      RETRIVE_RETURN_QUANTITY: new UntypedFormControl("", [Validators.required]),
      TYPE: new UntypedFormControl("Product"),
      RETRIVE_NOTES: new UntypedFormControl('')
    });
    this.retrivalRequestForm.controls["RETRIVE_RETURN_QUANTITY"].setValue(this.Content.content.ReturnAmount);
    this.retrivalRequestForm.controls["RETRIVE_RETURN_QUANTITY"].disable();

    this.returnList = [
      { "value": "Cheque", "label": "Cheque" },
      { "value": "BankAccount", "label": "Bank account" },
    ];

    this.typeList = [
      { "value": "Product", "label": "Product", checked: true }
    ]

    this.returnList = [{ label: "Select", value: null, checked: true }].concat(this.returnList);
  }


  save() {
    if (this.ValidateControls()) {

      var formData = this.retrivalRequestForm.value;
      formData["RETRIVE_RETURN_QUANTITY"] = parseInt(this.retrivalRequestForm.controls["RETRIVE_RETURN_QUANTITY"].value);
      formData["ProductID"] = this.Content.content.id;
      this.summaryService.Insert("api/ISTAllRequests/UpdateRetrivalStatus", formData).subscribe(result => {
        if (result.Status === 0) {
          this.commonService.SuccessBanner("Retrieval Request raised successfully")
          this.modalRef.close();
        }
      });
    }
  }

  ValidateControls(): boolean {
    let isValid: boolean = true;
    let message = "";
    let TYPE = this.retrivalRequestForm.controls["TYPE"].value;
    let RETRIVE_RETURN_QUANTITY = $("#RETRIVE_RETURN_QUANTITY").val();
    let RETRIVE_NOTES = $("#RETRIVE_NOTES").val();

    if (this.staticformFields?.RETRIEVE_TYPE.IS_Display) {
      if (this.staticformFields?.RETRIEVE_TYPE.IS_MANDATORY
        && (TYPE == null || TYPE == "" || TYPE == undefined)) {
        $("#TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#TYPE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.RETRIEVE_TYPE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#TYPE").addClass("ng-untouched ng-valid");
        $("#TYPE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.RETRIVE_RETURN_QUANTITY.IS_Display) {
      if (this.staticformFields?.RETRIVE_RETURN_QUANTITY.IS_MANDATORY
        && (RETRIVE_RETURN_QUANTITY == null || RETRIVE_RETURN_QUANTITY == "" || RETRIVE_RETURN_QUANTITY == undefined)) {
        $("#RETRIVE_RETURN_QUANTITY").addClass("ng-touched ng-invalid validate-error");
        $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.RETRIVE_RETURN_QUANTITY.LABEL_NAME}<br/>`;
        isValid = false;
      }
      else {
        $("#RETRIVE_RETURN_QUANTITY").addClass("ng-untouched ng-valid");
        $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.RETRIVE_PROD_NOTES.IS_Display) {
      if (this.staticformFields?.RETRIVE_PROD_NOTES.IS_MANDATORY
        && (RETRIVE_NOTES == null || RETRIVE_NOTES == "" || RETRIVE_NOTES == undefined)) {
        $("#RETRIVE_NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#RETRIVE_NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.RETRIVE_PROD_NOTES.LABEL_NAME}<br/>`;
        isValid = false;
      }
      else {
        $("#RETRIVE_NOTES").addClass("ng-untouched ng-valid");
        $("#RETRIVE_NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.RETRIVE_RETURN_QUANTITY.IS_Display) {
      if (RETRIVE_RETURN_QUANTITY !== null && RETRIVE_RETURN_QUANTITY !== "" && RETRIVE_RETURN_QUANTITY !== undefined) {
        const phoneformat = /^[1-9]\d*$/;
        RETRIVE_RETURN_QUANTITY = RETRIVE_RETURN_QUANTITY + "";
        if (RETRIVE_RETURN_QUANTITY.match(phoneformat)) {
          $("#RETRIVE_RETURN_QUANTITY").addClass("ng-untouched ng-valid");
          $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#RETRIVE_RETURN_QUANTITY").addClass("ng-touched ng-invalid validate-error");
          $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-untouched ng-valid");
          message += `Please enter Valid ${this.staticformFields?.RETRIVE_RETURN_QUANTITY.LABEL_NAME} <br/>`;
          isValid = false;
        }
        var floatRerive = parseFloat(RETRIVE_RETURN_QUANTITY);
        var allocated = parseFloat(this.Content.content.Allocated);
        if (floatRerive > allocated) {
          $("#RETRIVE_RETURN_QUANTITY").addClass("ng-touched ng-invalid validate-error");
          $("#RETRIVE_RETURN_QUANTITY").removeClass("ng-untouched ng-valid");
          message += `${this.staticformFields?.RETRIVE_RETURN_QUANTITY.LABEL_NAME} should be less than ${this.staticformFields?.ALLOCATED_QUANTITY.LABEL_NAME} <br/>`;
          isValid = false;
        }
      }
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);

    return isValid;
  }
}
